/**
 * Los teléfonos de WhatsApp, sin dependencias: se usan desde el cliente de contactos y desde el helper
 * de tipos de canal, y tienen que poder probarse con jest sin el entorno de Vite.
 */

/** "5493517733850@s.whatsapp.net" → "5493517733850". */
export function phoneFromThread(externalThreadId: string): string {
  return (externalThreadId || "").split("@")[0].replace(/\D/g, "");
}

/** Número de WhatsApp legible: saca el 9 de móvil AR y agrupa como `+54 351 7733850`. */
export function formatWhatsappPhone(externalThreadId: string): string {
  let d = phoneFromThread(externalThreadId);
  if (!d) return externalThreadId;
  if (d.startsWith("549")) d = `54${d.slice(3)}`; // AR: quitar el 9 de móvil
  if (d.startsWith("54") && d.length >= 5) {
    const local = d.slice(2);
    const area = local.slice(0, 3);
    const rest = local.slice(3);
    return `+54 ${area} ${rest}`.trim();
  }
  return `+${d}`;
}

/**
 * JID de WhatsApp a partir del número de un contacto. En AR el móvil lleva el **9** tras el 54
 * (54 <area><num> → 549 <area><num>), que el contacto guarda sin él. Inserta el 9 para poder enviar.
 */
export function toWhatsappJid(rawPhone: string): string {
  let d = (rawPhone || "").replace(/^"|"$/g, "").replace(/\D/g, "");
  if (d.startsWith("54") && !d.startsWith("549")) d = `549${d.slice(2)}`;
  return `${d}@s.whatsapp.net`;
}
